/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close-icon': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M11.537 2.462a.583.583 0 0 0-.825 0L7 6.174 3.288 2.462l-.081-.068a.584.584 0 0 0-.744.893l3.712 3.712-3.712 3.712-.068.081a.584.584 0 0 0 .893.744L7 7.824l3.712 3.712.081.068a.584.584 0 0 0 .744-.893L7.825 7l3.712-3.712.068-.081a.583.583 0 0 0-.068-.744z" _fill="#D5DAF4"/>'
  }
})
